export default __webpack_public_path__ + "static/media/Ucho Czlowieka.201c814f.png";